import React, { FC } from 'react';

import { HarvestSummaryTabProps } from './HarvestSummary.props';

import HarvestSummaryTabContent from './HarvestSummaryTabContent';
const AllHarvestSummary: FC<HarvestSummaryTabProps> = (props) => {
  return <HarvestSummaryTabContent {...props}></HarvestSummaryTabContent>;
};

export default AllHarvestSummary;
